// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jHdr","left":"styles_left__2YX_r"};